
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDashboardContext } from '../components/Context/DashboardContext';
import { startSignalRConnection } from "../services/signalRService";
import { TranslationContext } from '../components/Context/TranslationContext';

const HeaderPartner = () => {
    const { translations, language, setLanguage, isRTL } = useContext(TranslationContext);
    const navigate = useNavigate();
    const didFetch = React.useRef(false);
    const { profile, profileData } = useDashboardContext();
    const [isToggled, setIsToggled] = useState(false);
    const handleSignout = () => {
        // Clear user data from localStorage or context
        localStorage.removeItem('token');
        localStorage.removeItem('userType');
        // Navigate to login page
        navigate('/login');
    };
    const getData = async (token) => {

        await profile();
    }
    const toggleLanguage = () => {
        debugger;
        setLanguage(language === 'en' ? 'ar' : 'en');
        localStorage.setItem("lang", language === 'en' ? 'ar' : 'en');
        const newLanguage = isRTL === true ? "rtl" : "ltr";
        document.documentElement.dir = newLanguage;
    };

    React.useEffect(() => {       
        //const newLanguage = localStorage.getItem("lang") === "ar"? "rtl" : "ltr";
        //document.documentElement.dir = newLanguage;
        
        if (!didFetch.current) {
            getData();
          
            didFetch.current = true; // Mark the API call as done
        }
        startSignalRConnection();
        const body = document.body;
        const mobileNavToggle = document.querySelector('.mobile-nav-toggle');

        if (isToggled) {
            body.classList.add('toggle-sidebar');
            //mobileNavToggle.classList.add('bi-x');
            //mobileNavToggle.classList.remove('bi-list');
        } else {
            body.classList.remove('toggle-sidebar');
            //mobileNavToggle.classList.remove('bi-x');
            //mobileNavToggle.classList.add('bi-list');
        }
    }, [isToggled]);

    const handleToggleSidebar = () => {
        setIsToggled(prevState => !prevState);
    };

    const generateAvatar = (initial) => {
        const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
            <rect width="100%" height="100%" fill="#02176D" /> <!-- Updated with the detected color -->
            <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="40" fill="#fff" font-family="Arial">
                ${initial}
            </text>
        </svg>`;
    return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

    // Function to get the first initial from `firstName`
    const getFirstInitial = (firstName) => {
        return firstName?.charAt(0)?.toUpperCase() || "G"; // Default to 'G' if firstName is missing
    };

    // Generate the profile picture URL
    const profilePictureUrl = profileData?.firstName
        ? generateAvatar(getFirstInitial(profileData.firstName))
        : generateAvatar("G"); // Default to 'G' if profileData or firstName is unavailable

    return (
        <div> {profileData && <div>
            <header id="header" className="header fixed-top d-flex align-items-center" style={{ direction: "ltr" }}>

                <div className="d-flex align-items-center justify-content-between">
                    <a href="index.html" className="logo d-flex align-items-center">
                      <img 
  src="assets/img/Car Chemist Logo-Main.svg" 
  alt="Logo" 
  style={{ height: '30px' }} 
/>

                        
                    </a>
                    <i className="bi bi-list toggle-sidebar-btn" onClick={handleToggleSidebar}></i>
                </div>

                <div className="search-bar">
                    <form className="search-form d-flex align-items-center" method="POST" action="#">
                        <input type="text" name="query" placeholder="Search" title="Enter search keyword"></input>
                        <button type="submit" title="Search"><i className="bi bi-search"></i></button>
                    </form>
                </div>

                <nav className="header-nav ms-auto">
                    <ul className="d-flex align-items-center">

                        <li className="nav-item d-block d-lg-none">
                            <a className="nav-link nav-icon search-bar-toggle " href="#">
                                <i className="bi bi-search"></i>
                            </a>
                        </li>

                        <li className="nav-item dropdown">

                            <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
                                <i className="bi bi-bell"></i>
                                <span className="badge bg-primary badge-number">4</span>
                            </a>

                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
                                <li className="dropdown-header">
                                    You have 4 new notifications
                                    <a href="#"><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li className="notification-item">
                                    <i className="bi bi-exclamation-circle text-warning"></i>
                                    <div>
                                        <h4>Lorem Ipsum</h4>
                                        <p>Quae dolorem earum veritatis oditseno</p>
                                        <p>30 min. ago</p>
                                    </div>
                                </li>

                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li className="notification-item">
                                    <i className="bi bi-x-circle text-danger"></i>
                                    <div>
                                        <h4>Atque rerum nesciunt</h4>
                                        <p>Quae dolorem earum veritatis oditseno</p>
                                        <p>1 hr. ago</p>
                                    </div>
                                </li>

                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li className="notification-item">
                                    <i className="bi bi-check-circle text-success"></i>
                                    <div>
                                        <h4>Sit rerum fuga</h4>
                                        <p>Quae dolorem earum veritatis oditseno</p>
                                        <p>2 hrs. ago</p>
                                    </div>
                                </li>

                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li className="notification-item">
                                    <i className="bi bi-info-circle text-primary"></i>
                                    <div>
                                        <h4>Dicta reprehenderit</h4>
                                        <p>Quae dolorem earum veritatis oditseno</p>
                                        <p>4 hrs. ago</p>
                                    </div>
                                </li>

                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>
                                <li className="dropdown-footer">
                                    <a href="#">Show all notifications</a>
                                </li>

                            </ul>

                        </li>



                        <li className="nav-item dropdown pe-3">

                            <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                                {/* Dynamic Profile Picture */}
                                <img src={profilePictureUrl} alt="Profile" className="rounded-circle" />
                                {/* Display First Name */}
                                <span className="d-none d-md-block dropdown-toggle ps-2">
                                    {profileData?.firstName || "Guest"}
                                </span>
                            </a>

                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                                <li className="dropdown-header">
                                    <h6>{profileData.firstName} {profileData.lastName}</h6>
                                    <span>{profileData.userRole}</span>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="users-profile.html">
                                        <i className="bi bi-person"></i>
                                        <span>My Profile</span>
                                    </a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="users-profile.html">
                                        <i className="bi bi-gear"></i>
                                        <span>Account Settings</span>
                                    </a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="pages-faq.html">
                                        <i className="bi bi-question-circle"></i>
                                        <span>Need Help?</span>
                                    </a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider"></hr>
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="#" onClick={handleSignout}>
                                        <i className="bi bi-box-arrow-right"></i>
                                        <span>Sign Out</span>
                                    </a>
                                </li>

                            </ul>
                        </li>

                    </ul>
                </nav>

            </header>
            <aside id="sidebar" className={`sidebar ${isRTL === false ? "start-0" : "end-0"}`} style={{ width: "250px" }}>

                <ul className="sidebar-nav" id="sidebar-nav">
                    <li className="nav-heading">Pages</li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/dashboard">
                            <i className="bi bi-info-circle"></i>
                            <span>{translations["dashboard"] || "Dashboard"}</span>
                        </a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/branch">
                            <i className="bi bi-person"></i>
                            <span>{translations["branch"]}</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="pages-contact.html">
                            <i className="bi bi-person"></i>
                            <span>{translations["customers"]}</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/allemployee">
                            <i className="bi bi-person"></i>
                            <span>{translations["employee"]}</span>
                        </a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="orders">
                            <i className="bi bi-card-list"></i>
                            <span>{translations["orders"]}</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/viewpackage">
                            <i className="bi bi-person"></i>
                            <span>{translations["packages"]}</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/CoupanList">
                            <i className="bi bi-envelope"></i>
                            <span>{translations["coupons & offers"]}</span>
                        </a>
                    </li>


                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/partnerservice">
                            <i className="bi bi-card-list"></i>
                            <span>{translations["service"]}</span>
                        </a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="/products">
                            <i className="bi bi-card-list"></i>
                            <span>Products</span>
                        </a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="pages-error-404.html">
                            <i className="bi bi-dash-circle"></i>
                            <span>{translations["general settings"]}</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link collapsed" href="#" onClick={(e) => { e.preventDefault(); toggleLanguage(); }}>
                            <i className="bi bi-translate"></i>
                            <span>{language === 'en' ? 'Switch to Arabic' : 'Switch to English'}</span>
                        </a>
                    </li>
                  


                </ul>

            </aside>
        </div>}</div>
    );
};

export default HeaderPartner;
